// extracted by mini-css-extract-plugin
export default {"card":"zyEDqKzU4jSL_23bx16E","card--hoverable":"jK7ktkBwOPC4wJ4iUiEO","card--selected":"ym2NjdZgxyhaZkxVziO4","bounce":"hb9TMCPcnwxmmAVrjzDL"};